import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import {appValidateUrl} from '@core/validator/url.validator';

export const appFormValidateUrl: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
        return null;
    }

    return appValidateUrl(control.value) ? null : {invalidUrl: true};
}
